'use client';

import { useEffect } from 'react';

import { useHeaderVariant } from '@/shared/contexts/HeaderVariantContext';

export default function EventsHubLayout({ children }: { children: React.ReactNode }) {
  const { setLNBOverlay } = useHeaderVariant();

  useEffect(() => {
    setLNBOverlay(true);
    return () => {
      setLNBOverlay(null);
    };
  }, [setLNBOverlay]);

  return <>{children}</>;
}
